export const IMPORT_TYPES = {
  PIX: "pix",
  CREDITO_DEBITO: "CreditoDebito",
} as const;

export type ImportType = (typeof IMPORT_TYPES)[keyof typeof IMPORT_TYPES];

interface ImportTypeConfig {
  acceptedExtension: string;
  acceptAttribute: string;
  displayFormat: string;
  errorMessage: string;
}

const IMPORT_TYPE_CONFIG: Record<ImportType, ImportTypeConfig> = {
  [IMPORT_TYPES.PIX]: {
    acceptedExtension: "csv",
    acceptAttribute: ".csv",
    displayFormat: ".csv",
    errorMessage: "Para importação PIX, apenas arquivos CSV são permitidos.",
  },
  [IMPORT_TYPES.CREDITO_DEBITO]: {
    acceptedExtension: "xlsx",
    acceptAttribute: ".xlsx",
    displayFormat: ".xlsx",
    errorMessage:
      "Para importação Crédito/Débito, apenas arquivos XLSX são permitidos.",
  },
};

export const getFileExtension = (filename: string): string => {
  return filename.split(".").pop()?.toLowerCase() || "";
};

export const getAcceptedFileTypes = (importType: string): string => {
  const config = IMPORT_TYPE_CONFIG[importType as ImportType];
  return config?.acceptAttribute || ".xlsx,.csv";
};

export const getDisplayFormat = (importType: string): string => {
  const config = IMPORT_TYPE_CONFIG[importType as ImportType];
  return config?.displayFormat || ".xlsx, .csv";
};

export const validateFileType = (
  file: File,
  importType: string
): { valid: boolean; error?: string } => {
  const config = IMPORT_TYPE_CONFIG[importType as ImportType];

  if (!config) {
    return { valid: true };
  }

  const fileExtension = getFileExtension(file.name);

  if (fileExtension !== config.acceptedExtension) {
    return {
      valid: false,
      error: config.errorMessage,
    };
  }

  return { valid: true };
};
